import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  ${({ theme }) => theme.gap(2)};
  padding: ${props => props.theme.space(1)} ${props => props.theme.space(3)};
  max-width: max-content;
  border-radius: 20px;

  p {
    align-self: center;
    margin-bottom: 0;
  }

  ${props => props.isUniBlue && `background: ${props.theme.unisystem.pill.background.uniBlue}`};
  ${props => props.isBlue && `background: ${props.theme.unisystem.pill.background.blue}`};
  ${props => props.isRed && `background: ${props.theme.unisystem.pill.background.red}`};
  ${props => props.isYellow && `background: ${props.theme.unisystem.pill.background.yellow}`};
  ${props => props.isGrey && `background: ${props.theme.unisystem.pill.background.grey}`};
  ${props => props.isGreen && `background: ${props.theme.unisystem.pill.background.green}`};
`;
